<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #modal-lead-status {
    .modal-content {
      border:0;
      width: 415px;
      height: 286px;
    }

    .modal-header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      padding: 16px 24px 16px 24px;
    }

    .modal-body {
      background-color: $salesflow-background-content;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      padding:16px 24px 24px 24px;
    }

    .modal-title {
      font-size: 12px;
      font-family: 'Montserrat';
    }

    .lead-status-modal-footer {
      padding: 0 !important;
      display: flex;
      flex-direction: column;
    }

    .bg-salesflow-bg-body {
      background-color: transparent !important;
    }

    .lead-status-label {
      @include salesflow-text;
      font-weight: 500;
    }

    #lead-status-select {
      border-radius: 8px;
      border: 1px solid $salesflow-outline-gray-medium;
      background-color: $salesflow-font-white;
      width: 367px;
      height: 54px;
      padding: 17px 27px 17px 16px;

      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      font-family: 'Montserrat';
      color: $salesflow-font-gray;
    }

    .btn-save-status-lead {
      margin-right: 0;
      margin-top: 16px;
    }

    .close {
      margin:initial;
    }

    .btn-cancel-status-lead {
      color: $salesflow-font-gray;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      align-content: center;
      margin-top: 16px;
      opacity: unset;
    }

    .btn-cancel-status-lead:hover{
      color: $salesflow-primary-hover;
    }
  }
</style>

<template>
  <div class="lead-status">
    <a
      class="dashed"
      href="javascript:void(0);"
      @click="selectStatus()"
      v-if="current"
      :class="customClass"
      data-ignore-unsaved-check
    >{{ current ? __(current.name) : __('Novo') }}</a>
    <BModal
      id="modal-lead-status"
      ref="modal-lead-status"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Alterar Status') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-lead-status'].hide()"
          data-ignore-unsaved-check
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <div class="form-group">
          <label class="lead-status-label">Status</label>
          <select
            id="lead-status-select"
            class="form-control"
            v-model="status_id"
          >
            <option
              :value="single.id"
              v-for="single in statuses"
            >
             {{ __(truncate(single.name, 53)) }}
            </option>
          </select>
        </div>
        <div class="modal-footer lead-status-modal-footer bg-salesflow-bg-body default-modal-footer">
          <button
            class="salesflow-btn salesflow-btn-secondary btn-save-status-lead"
            type="submit"
            @click.prevent="save"
          >
            {{ __('Salvar') }}
          </button>
          <button
            class="close btn-cancel-status-lead"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            @click="$refs['modal-lead-status'].hide()"
            >
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  created () {
    if (_.size(this.current) == 0) {
      this.current = this.statuses[0];
    }
  },

  mounted () {
    this.status_id = this.current.id;

    Bus.$on('leadUpdated', (lead) => this.current.id = lead.status_id);
  },

  props: {
    hash: {
      required: true,
    },
    status: {
      required: true,
    },
    statuses: {
      required: true,
    },
    customClass: {
      default: null,
    },
  },

  data () {
    return {
      current: this.status,
      status_id: null,
    };
  },

  methods: {
    truncate(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      } else {
        return text;
      }
    },
    selectStatus () {
      this.$refs['modal-lead-status'].show();
    },

    save () {
      this.$refs['modal-lead-status'].hide();

      this.current = this.getStatusById(this.status_id);

      this.$http.put(`/lead/${this.hash}`, { status: this.status_id })
        .then(({ data }) => {
          Bus.$emit('leadUpdated', data);
        });
    },

    getStatusById (status_id) {
      return _.find(this.statuses, (status) => status.id == this.status_id);
    },
  },
};
</script>
